var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExperimentsinline = function SvgExperimentsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#experiments_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92 5.678v-4.44h4.16v4.44c0 .495.154.977.44 1.38l4.142 5.82a1.19 1.19 0 0 1-.97 1.88H2.308a1.19 1.19 0 0 1-.97-1.88l4.142-5.82a2.4 2.4 0 0 0 .44-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M4.318 1.238h7.198M3.5 9.904h9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "experiments_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgExperimentsinline;